
import { defineComponent } from 'vue'

import BaseDescriptions from '@/base-ui/descriptions'
import BaseTextLink from '@/base-ui/text-link'
// import HyCode from '@/base-ui/code'
import BaseCard from '@/base-ui/card'
import { technologyStacks } from './config'

export default defineComponent({
  components: {
    BaseCard,
    BaseTextLink,
    BaseDescriptions
  },

  setup() {
    return {
      technologyStacks
    }
  }
})
